<template>
  <DialogModal :is-destructive-alert="false" @secondary="$emit('cancel')" @primary="$emit('agree')">
    <span slot="header" v-localize="HEADER_TEXT_KEY" />
    <span slot="body"></span>
    <span slot="secondary-button-text" v-localize="SECONDARY_BUTTON_TEXT_KEY" />
    <span slot="primary-button-text" v-localize="PRIMARY_BUTTON_TEXT_KEY" />
  </DialogModal>
</template>

<script>
import DialogModal from '@/components/AvatarBuilderUI/Dialogs/DialogModal.vue';
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'OutfitDialog',
  components: {
    DialogModal,
  },
  created: function() {
    this.HEADER_TEXT_KEY = 'CategoryOutfitDialogTitle';
    this.SECONDARY_BUTTON_TEXT_KEY = 'No';
    this.PRIMARY_BUTTON_TEXT_KEY = 'Yes';
  },
  directives: {
    LocalizationDirective,
  },
};
</script>
